import { IAdHocProjectGroupResult, IAdHocProjectResult, IExportGroupProject, IGroupProject, IProject, IProjecToPost } from "../../models/applicationState";
import { Dispatch } from "redux";
import { createPayloadAction, IPayloadAction } from "./actionCreators";
import { ActionTypes } from "./actionTypes";
import AdHocOcrV3Service from "../../services/adHocOcrV3Service";

export default interface IAdHocOcrV3Actions {
    loadAdHocOcrV3Project(documentId: string): Promise<IProject>;

    exportProjectLabelToSource(projectId: string, runGenerateModel: boolean);

    loadAdHocOcrV3GroupProject(groupId: string): Promise<IGroupProject>;
    loadAdHocOcrV3ProjectFromGroup(project: IAdHocProjectResult);
    exportGroupProjectLabelToSource(exportGroupProject: IExportGroupProject);

    //loadAdHocOcrV3GroupProjectDocument(groupId: string, documentId: string, docPosition: number): Promise<IProject>;
    loadAdHocOcrV3GroupProjectDocument(groupId: string);
    toggleProjectToPost(projectId: string, fileName: string, selected: boolean, generateModel: boolean);
    setGenerateModel(projectId: string, generateModel: boolean);

    loadProject(projectId: string, setActive: boolean);
}

export function loadAdHocOcrV3Project(documentId: string): (dispatch: Dispatch) => Promise<void> {
    return async (dispatch: Dispatch) => {
        try {
            const service = new AdHocOcrV3Service();
            const project = await service.load(documentId);
            if (project) {
                dispatch(loadAdHocOcrV3ProjectAction(project));
            }
        }
        catch(e) {
            return Promise.reject(e);
        }
    }
}

export interface ILoadAdHocOcrV3ProjectAction extends IPayloadAction<string, IAdHocProjectResult> {
    type: ActionTypes.AD_HOC_OCR_V3_LOAD_PROJECT
}

export const loadAdHocOcrV3ProjectAction = createPayloadAction<ILoadAdHocOcrV3ProjectAction>(ActionTypes.AD_HOC_OCR_V3_LOAD_PROJECT);

export function exportProjectLabelToSource(projectId: string, runGenerateModel: boolean) {
    return async (dispatch: Dispatch) => {
        try {
            const adHocOcrService = new AdHocOcrV3Service();
            const result = await adHocOcrService.exportProjectLabelToSource(projectId, runGenerateModel);
            return Promise.resolve(result);
        }
        catch(e) {
            return Promise.reject(e);
        }
    }    
}

export function loadAdHocOcrV3GroupProject(groupId: string): (dispatch: Dispatch) => Promise<void> {
    return async (dispatch: Dispatch) => {
        try {
            const service = new AdHocOcrV3Service();
            const group = await service.loadGroup(groupId);
            //if (group) {
            if (group && group.adHocProjectModels && group.adHocProjectModels.length > 0) {
                dispatch(loadAdHocOcrV3ProjectAction(group.adHocProjectModels[0]));
                // const unpostedDocs = group.adHocProjectModels.filter(r => r.status.toLowerCase() !== 'posted');
                // if (unpostedDocs.length > 0) {
                //     dispatch(loadAdHocOcrV3ProjectAction(unpostedDocs[0]));
                // }
                // else {
                //     dispatch(loadAdHocOcrV3ProjectAction(group.adHocProjectModels[0]));
                // }
                dispatch(loadAdHocOcrV3GroupProjectAction(group));
            }
        }
        catch(e) {
            return Promise.reject(e);
        }
    }
}

export function loadAdHocOcrV3ProjectFromGroup(project: IAdHocProjectResult) {
    return async (dispatch: Dispatch) => {
        dispatch(loadAdHocOcrV3ProjectAction(project));
    }
}

export interface ILoadAdHocOcrV3GroupProjectAction extends IPayloadAction<string, IAdHocProjectGroupResult> {
    type: ActionTypes.AD_HOC_OCR_V3_LOAD_GROUP_PROJECT
}

export const loadAdHocOcrV3GroupProjectAction = createPayloadAction<ILoadAdHocOcrV3GroupProjectAction>(ActionTypes.AD_HOC_OCR_V3_LOAD_GROUP_PROJECT);

export function exportGroupProjectLabelToSource(exportGroupProject: IExportGroupProject) {
    return async (dispatch: Dispatch) => {
        try {
            const service = new AdHocOcrV3Service();
            const result = await service.exportGroupProjectLabelToSource(exportGroupProject);
            if (result && typeof result === 'boolean') {
                dispatch(removeAdHocOcrV3GroupProjectDocumentAction(exportGroupProject));
                dispatch(setAdHocOcrV3ProjectPostedAction(exportGroupProject));
            }
            return Promise.resolve(result);
        }
        catch(error) {
            return Promise.reject(error);
        }
        
    }    
}

export interface IRemoveAdHocOcrV3GroupProjectDocumentAction extends IPayloadAction<string, IExportGroupProject> {
    type: ActionTypes.AD_HOC_OCR_V3_REMOVE_GROUP_PROJECT_DOCUMENT
}

export const removeAdHocOcrV3GroupProjectDocumentAction = createPayloadAction<IRemoveAdHocOcrV3GroupProjectDocumentAction>(ActionTypes.AD_HOC_OCR_V3_REMOVE_GROUP_PROJECT_DOCUMENT);


export function loadProject(documentId: string, setActive: boolean = false): (dispatch: Dispatch) => Promise<void> {
    return async (dispatch: Dispatch) => {
        try {
            const service = new AdHocOcrV3Service();
            const project = await service.load(documentId);
            if (project) {
                dispatch(loadAdHocOcrV3GroupProjectDocumentAction(project));
            }
            if (setActive) {
                await dispatch(loadAdHocOcrV3ProjectAction(project));
            }
        }
        catch(e) {
            return Promise.reject(e);
        }
    }
}

// export function loadAdHocOcrV3GroupProjectDocument(
//     groupId: string,
//     documentId: string,
//     docPosition: number
// ): (dispatch: Dispatch) => Promise<void> {
//     return async (dispatch: Dispatch) => {
//         try {
//             const service = new AdHocOcrV3Service();

//             // Await the service call to load the group document
//             const document = await service.loadGroupDocument(groupId, documentId);

//             if (document) {
//                 // Dispatch the action to load the document into the Redux store
//                 dispatch(loadAdHocOcrV3GroupProjectDocumentAction(document));

//                 // If the document position is 0, dispatch another action
//                 if (docPosition === 0) {
//                     await dispatch(loadAdHocOcrV3ProjectAction(document));
//                 }
//             }
//         } catch (error) {
//             console.error("Error loading AdHoc OCR V3 Group Project Document:", error);

//             // Optionally, handle the error (e.g., dispatch an error action or log it)
//             throw error; // Propagate the error to the caller
//         }
//     };
// }

export function loadAdHocOcrV3GroupProjectDocument(
    groupId: string
): (dispatch: Dispatch) => Promise<void> {
    return async (dispatch: Dispatch) => {
        try {
            const service = new AdHocOcrV3Service();

            // Await the service call to load the group document
            await service.loadGroupDocument(groupId);
            
        } catch (error) {
            console.error("Error loading AdHoc OCR V3 Group Project Document:", error);

            // Optionally, handle the error (e.g., dispatch an error action or log it)
            throw error; // Propagate the error to the caller
        }
    };
}

export interface ILoadAdHocOcrV3GroupProjectDocumentAction extends IPayloadAction<string, IAdHocProjectResult> {
    type: ActionTypes.AD_HOC_OCR_V3_LOAD_GROUP_PROJECT_DOCUMENT
}

export const loadAdHocOcrV3GroupProjectDocumentAction = createPayloadAction<ILoadAdHocOcrV3GroupProjectDocumentAction>(ActionTypes.AD_HOC_OCR_V3_LOAD_GROUP_PROJECT_DOCUMENT);

export interface ILoadAdHocOcrV3GroupProjectDocumentRefreshAction extends IPayloadAction<string, string> {
    type: ActionTypes.AD_HOC_OCR_V3_LOAD_GROUP_PROJECT_DOCUMENT_REFRESH
}

export const loadAdHocOcrV3GroupProjectDocumentRefreshAction = createPayloadAction<ILoadAdHocOcrV3GroupProjectDocumentRefreshAction>(ActionTypes.AD_HOC_OCR_V3_LOAD_GROUP_PROJECT_DOCUMENT_REFRESH);

export function toggleProjectToPost(projectId: string, fileName: string, selected: boolean, generateModel: boolean): (dispatch: Dispatch) => Promise<void> {
    return async (dispatch: Dispatch) => {
        dispatch(toggleProjectToPostAction({
            projectId,
            fileName,
            selected,
            generateModel
        }));        
    }
}

export interface IToggleProjectToPostAction extends IPayloadAction<string, IProjecToPost> {
    type: ActionTypes.AD_HOC_OCR_V3_TOGGLE_PROJECT_TO_POST
}

export const toggleProjectToPostAction = createPayloadAction<IToggleProjectToPostAction>(ActionTypes.AD_HOC_OCR_V3_TOGGLE_PROJECT_TO_POST);

export interface ISetAdHocOcrV3ProjectPostedStatusAction extends IPayloadAction<string, IExportGroupProject> {
    type: ActionTypes.AD_HOC_OCR_V3_SET_PROJECT_POSTED_STATUS
}

export const setAdHocOcrV3ProjectPostedAction = createPayloadAction<ISetAdHocOcrV3ProjectPostedStatusAction>(ActionTypes.AD_HOC_OCR_V3_SET_PROJECT_POSTED_STATUS);

export function setGenerateModel(projectId: string, generateModel: boolean): (dispatch: Dispatch) => Promise<void> {
    return async (dispatch: Dispatch) => {
        const service = new AdHocOcrV3Service();
        service.setGenerateModel(projectId, generateModel);
    }
}
